"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountType = exports.useGlobalAuth = exports.globalAuthContext = void 0;
var globalAuthContext_1 = require("./globalAuthContext");
Object.defineProperty(exports, "globalAuthContext", { enumerable: true, get: function () { return globalAuthContext_1.globalAuthContext; } });
var useGlobalAuth_1 = require("./useGlobalAuth");
Object.defineProperty(exports, "useGlobalAuth", { enumerable: true, get: function () { return useGlobalAuth_1.useGlobalAuth; } });
Object.defineProperty(exports, "AccountType", { enumerable: true, get: function () { return useGlobalAuth_1.AccountType; } });
